module.exports = __webpack_public_path__ + "static/media/hammer.1519aeba.svg";